import classNames from 'classnames';
import ArrowRight from '../../images/icon-arrow-right.svg';

export type ButtonProps = JSX.IntrinsicElements['button'];

export const Button = ({ children, className, ...props }: ButtonProps) => (
  <button {...props} className={classNames('button', className)}>
    <span>{children}</span> <ArrowRight />
  </button>
);
